import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    sectionTitle: {
      color: theme.gray800,
      fontSize: "16px",
      lineHeight: "24px",
    },
    OLTable: {
      "& tr:last-child td": {
        borderLeft: "none",
        borderRight: "none",
      },
      "& tr:last-child td:after": {
        borderLeft: "none",
        borderRight: "none",
      },
    },
    alignLeft: { justifyContent: "flex-start" },
    labelItem: {
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
      background: theme.gray100,
      borderRadius: theme.spacing(2),
      color: theme.gray800,
      cursor: "pointer",
      padding: theme.spacing(3, 6),
      margin: theme.spacing(2),
      marginLeft: "0",
      "&+&": { marginLeft: theme.spacing(4) },
    },
  }),
);
